import FeaturedProductsCarousel from './FeaturedProductsCarousel';
import { connect } from 'react-redux';

import { analyticsActions } from 'src/analytics/store';

interface IDispatchFromProps {
  fireProductImpressionEvent(data: any): void;
  fireProductClickEvent(data: any): void;
}

const mapDispatchToProps = (dispatch: any): IDispatchFromProps => ({
  fireProductImpressionEvent: (data: any) =>
    dispatch(analyticsActions.productImpression(data)),
  fireProductClickEvent: (data: any) =>
    dispatch(analyticsActions.productClick(data))
});

export default connect(null, mapDispatchToProps)(FeaturedProductsCarousel);
